<div class="order-box">
    <div class="orders-box-date">{{order.order_date}}</div>
    <div class="order-box-inner">
        <div class="order-box-inner-content">
            <div class="order-box-inner-content-box">
                <div class="order-box-inner-content-orderId">
                    <span>Order</span>
                    <span class="order-box-orderId">#{{order.id}}</span>
                </div>
                <div class="order-box-inner-content-status">
                    <span class="status-text">Status:</span>
                    <span class="order-box-inner-content-status-button" [style.background-color]="getOrderStatus(order.status).color">
                        <img [src]="getOrderStatus(order.status).icon">
                        {{getOrderStatus(order.status).text}}
                    </span>
                    <button class="btn py-2" style="border-radius: 200px; margin-right: 2rem; background-color: #FF897D;" (click)="payment.emit(order.to_pay)" *ngIf="order.to_pay">Pay now</button>
                </div>
            </div>
            <div class="order-box-inner-content-actions-box">
                <div class="order-box-inner-content-details" (click)="openPauseSubscription()" *ngIf="showSkip && isSubscriptionActive(order) && !isSubscriptionFlexi(order) && !order.pause_from">
                    <img src="assets/images/pause-circle.svg">
                    <span class="order-box-inner-content-details-link">Skip</span>
                </div>

                <div class="order-box-inner-content-details" (click)="openCancelSubscription()" *ngIf="showCancel && isSubscriptionActive(order) && !order.cancel_from">
                    <img src="assets/images/alert.svg">
                    <span class="order-box-inner-content-details-link">Cancel</span>
                </div>

                <div class="order-box-inner-content-details" (click)="details.emit(order.id)" *ngIf="showDetails && order.status !== 1 && order.status !== 8">
                    <img src="assets/images/order-details-link-icon.svg">
                    <span class="order-box-inner-content-details-link">Details</span>
                </div>
            </div>
        </div>
        <div *ngIf="order.cancel_from">
            Cancelation is set for: {{order.cancel_from}}
        </div>
        <div *ngIf="order.pause_from">
            Pause period: {{order.pause_from}} - {{order.pause_until}}
        </div>
    </div>
</div>

<!-- Pause Subscription Dialog -->
<p-dialog [draggable]="false" [blockScroll]="true" [resizable]="false" [(visible)]="pauseSubscriptionPopUpVisibility" (onHide)="closePauseSubscription()">
    <div>
        <div class="popup-header">
            <span>Pause Subscription</span>
        </div>
        <div>
            <form [formGroup]="pauseSubscriptionForm" (ngSubmit)="sendSubscriptionPause()" class="pause-form">
                <div class="pause-subscription-title">Select the deliveries you want to skip</div>
                <div class="pause-dropdown-wrapper">
                    <p-dropdown formControlName="pauseFromDate" [options]="pauseDates" optionLabel="label" optionValue="value" placeholder="Pause From" (onChange)="onPauseFromDateChange($event.value)" appendTo="body" styleClass="w-100"></p-dropdown>
                    <p-dropdown formControlName="pauseToDate" [options]="filteredPauseDates" optionLabel="label" optionValue="value" placeholder="Restart From" appendTo="body" styleClass="w-100"></p-dropdown>
                </div>
                <div style="display: flex; justify-content: center; margin-top: clamp(1rem, 3rem, 5vh);">
                    <button type="submit" style="background-color: #ef870a; color: white; border: none; padding: clamp(0.5rem, 0.75rem, 1rem) clamp(1rem, 2rem, 3rem); font-size: clamp(0.875rem, 1rem, 1.125rem); border-radius: 25px; cursor: pointer;" [disabled]="!pauseSubscriptionForm.valid">Confirm</button>
                </div>
            </form>
        </div>
    </div>
</p-dialog>

<!-- Cancel Subscription Dialog -->
<p-dialog [draggable]="false" [blockScroll]="true" [resizable]="false" [(visible)]="cancelSubscriptionPopUpVisibility" (onHide)="closeCancelSubscription()">
    <div>
        <div class="popup-header">
            <span>Cancel Subscription</span>
        </div>
        <p-divider></p-divider>
        <app-cancel-subscription
            [orderId]="order.id"
            [cancellationDates]="cancellationDates"
            (cancelled)="onSubscriptionCancelled($event)">
        </app-cancel-subscription>
    </div>
</p-dialog>
